import {
  createSlice,
  createSelector,
  createAsyncThunk,
  createEntityAdapter
} from '@reduxjs/toolkit'
import type { RootState } from '../store'
import { AxiosResponse } from "axios";
import { API_PATH } from '../constants';
import { IScenario } from '../interfaces';
import { http, httpImage } from '../utils/config';

const scenarioAdapter = createEntityAdapter<any>()

const initialState = scenarioAdapter.getInitialState()

// Thunk functions
export const fetchScenarios = createAsyncThunk('scenario/fetchScenarios', async () => {
  try {
  
    const response = await http.get(API_PATH + "/scenario");
    return response.data;
  } catch (error: any) {
    if (error.response && error.response.data.message) {
      return error.response.data.message
    } else {
      return error.message
    }
  }
})

export const fetchTagScenarios = createAsyncThunk('scenarios/fetchTagScenarios', async ({ locationTags, topicTags, detailsTags, searchString }: { locationTags: string[], topicTags: string[], detailsTags: string[], searchString: string }, { rejectWithValue }) => {
  try {
    
      const response = await http.post(API_PATH + '/scenario', { locationTags: locationTags, topicTags: topicTags, detailsTags: detailsTags, searchString: searchString });
      return response.data
  } catch (error: any) {
    if (error.response && error.response.data.message) {
      return error.response.data.message
    } else {
      return error.message
    }
  }
})

const scenarioSlice = createSlice({
    name: 'scenarios',
    initialState,
    reducers: {
      scenarioToggled(state, action) {
        //const scenarioId = action.payload
      }
    }
  /*extraReducers: (builder) => {
    builder
      .addCase(fetchScenarios.fulfilled, (state, action) => {
        scenarioAdapter.setAll(state, action.payload)
      })
      .addCase(fetchImages.pending, (state, action) => {
        // Add user to the state array
      })
  },*/
})

export const {
  scenarioToggled
} = scenarioSlice.actions

export default scenarioSlice.reducer

export const {
  selectAll: selectScenarios
} = scenarioAdapter.getSelectors((state: RootState) => state.scenarios)

export const updateScenario = createAsyncThunk(
  'scenarios/updateScenario',
  async (text: IScenario) => {
    try {
  
      const response = await http.put(API_PATH + '/scenario/' + text.id + '/info', { 'info': text });
      return response.data
    } catch (error: any) {
      return error;
    }
  }
)

export const getAllScenarios = createAsyncThunk(
  'scenarios/getAllScenarios',
  async () => {
    try {
  
      const response = await http.get(API_PATH + '/scenario/all');
      return response.data
    } catch (error: any) {
      return error;
    }
  }
)

export const createScenario = createAsyncThunk(
  'scenarios/createScenario',
  async (text: IScenario, { rejectWithValue }) => {
    try {

      let response: AxiosResponse<any, any> = await http.post(API_PATH + '/scenario/new', { info: text });
      let respObj: any = {};
      respObj.status = response.status;
      respObj.scenario = response.data;
      return respObj
    } catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message)
      } else {
        return rejectWithValue(error.message)
      }
    }
  }
)

export const publishScenario = createAsyncThunk(
  'scenarios/publishScenario',
  async (id: string, { rejectWithValue }) => {
    try {

      let response: AxiosResponse<any, any> = await http.post(API_PATH + '/scenario/' + id + '/publish', {});
      return response.data
    } catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message)
      } else {
        return rejectWithValue(error.message)
      }
    }
  }
)

export const copyScenario = createAsyncThunk(
  'scenarios/copyScenario',
  async (id: string, { rejectWithValue }) => {
    try {

      let response: AxiosResponse<any, any> = await http.post(API_PATH + '/scenario/' + id + '/copy', {});
      return response.data
    } catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message)
      } else {
        return rejectWithValue(error.message)
      }
    }
  }
)

export const updateSnippets = createAsyncThunk(
  'scenarios/updateSnippets',
  async ({ scenarioId, snippets }: { scenarioId: string, snippets: string[] }, { rejectWithValue }) => {
    try {

      let response: AxiosResponse<any, any> = await http.put(API_PATH + '/scenario/' + scenarioId + '/snippets', { snippets: snippets });
      return response.data
    } catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message)
      } else {
        return rejectWithValue(error.message)
      }
    }
  }
)

///// Start Snippets API /////

export const fetchSnippetsImages = createAsyncThunk(
  'scenarios/fetchSnippetsImages',
  async ({ scenarioId, turn }: { scenarioId: string, turn: number }) => {
    try {
      const response = await http.get(API_PATH + '/scenario/' + scenarioId + '/snippets/' + turn + '/images');
      return response.data
    } catch (error: any) {
      return error;
    }
  }
)

export const getSnippetsUploadUrl = createAsyncThunk(
  'scenarios/getSnippetsUploadUrl',
  async ({ scenarioId, turn, fileName }: { scenarioId: string, turn: number, fileName: string }, { rejectWithValue }) => {
    try {

      let response: AxiosResponse<any, any> = await http.post(API_PATH + '/scenario/' + scenarioId + '/snippets/' + turn + '/images', { fileName: fileName });
      return response.data;
    } catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message)
      } else {
        return rejectWithValue(error.message)
      }
    }
  }
)

export const uploadSnippetsImageFile = createAsyncThunk(
  'scenarios/uploadImageFile',
  async ({ imageFile, gcsUrl }: { imageFile: File, gcsUrl: string }, { rejectWithValue }) => {
    try {
      const formData = new FormData();
      formData.append("data", imageFile);
      let response = await httpImage.put(gcsUrl, imageFile);
      return response.data
    } catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message)
      } else {
        return rejectWithValue(error.message)
      }
    }
  }
)

export const uploadSnippetsImage64 = createAsyncThunk(
  'scenarios/uploadImage64',
  async ({ scenarioId, imageName, image64 }: { scenarioId: string, imageName: string, image64: string }, { rejectWithValue }) => {
    try {
      let response = await http.post(API_PATH + '/scenario/' + scenarioId + '/images64', { imageName: imageName, image64: image64 });
      return response.data
    } catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message)
      } else {
        return rejectWithValue(error.message)
      }
    }
  }
)

export const deleteSnippetsImage = createAsyncThunk(
  'scenarios/deleteImage',
  async ({ scenarioId, turn, fileName}: { scenarioId: string, turn: number, fileName: string | undefined }, { rejectWithValue }) => {
    try {

      let response = await http.delete(API_PATH + '/scenario/' + scenarioId + '/snippets/' + turn + '/image', {data: { fileName: fileName }});
      return response.data
    } catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message)
      } else {
        return rejectWithValue(error.message)
      }
    }
  }
)

///// End Snippets API /////

export const fetchImages = createAsyncThunk(
    'scenarios/fetchImages',
    async (id: string, { rejectWithValue }) => {
      try {
        const response = await http.get(API_PATH + '/scenario/' + id + '/images');
        return response.data
      } catch (error: any) {
        return rejectWithValue(error);
      }
    }
  )

  export const getUploadUrl = createAsyncThunk(
    'scenarios/uploadImages',
    async ({ scenarioId, fileName }: { scenarioId: string, fileName: string }, { rejectWithValue }) => {
      try {
  
        let response: AxiosResponse<any, any> = await http.post(API_PATH + '/scenario/' + scenarioId + '/images', { fileName: fileName });
        return response.data;
      } catch (error: any) {
        if (error.response && error.response.data.message) {
          return rejectWithValue(error.response.data.message)
        } else {
          return rejectWithValue(error.message)
        }
      }
    }
  )

  export const uploadImageFile = createAsyncThunk(
    'scenarios/uploadImageFile',
    async ({ imageFile, gcsUrl }: { imageFile: File, gcsUrl: string }, { rejectWithValue }) => {
      try {
        const formData = new FormData();
        formData.append("data", imageFile);
        let response = await httpImage.put(gcsUrl, imageFile);
        return response.data
      } catch (error: any) {
        if (error.response && error.response.data.message) {
          return rejectWithValue(error.response.data.message)
        } else {
          return rejectWithValue(error.message)
        }
      }
    }
  )

  export const uploadImage64 = createAsyncThunk(
    'scenarios/uploadImage64',
    async ({ scenarioId, imageName, image64 }: { scenarioId: string, imageName: string, image64: string }, { rejectWithValue }) => {
      try {
        let response = await http.post(API_PATH + '/scenario/' + scenarioId + '/images64', { imageName: imageName, image64: image64 });
        return response.data
      } catch (error: any) {
        if (error.response && error.response.data.message) {
          return rejectWithValue(error.response.data.message)
        } else {
          return rejectWithValue(error.message)
        }
      }
    }
  )

  export const deleteImage = createAsyncThunk(
    'scenarios/deleteImage',
    async ({ scenarioId, fileName}: { scenarioId: string, fileName: string | undefined }, { rejectWithValue }) => {
      try {
  
        let response = await http.delete(API_PATH + '/scenario/' + scenarioId + '/images', {data: { fileName: fileName }});
        return response.data
      } catch (error: any) {
        if (error.response && error.response.data.message) {
          return rejectWithValue(error.response.data.message)
        } else {
          return rejectWithValue(error.message)
        }
      }
    }
  )

  export const deleteScenario = createAsyncThunk(
    'games/deleteScenario',
    async (scenarioId: string, { rejectWithValue }) => {
      try {
  
        let response: any = {}
        response = await http.delete(API_PATH + '/scenario/' + scenarioId);
        return response.data
      } catch (error: any) {
        if (error.response && error.response.data.message) {
          return rejectWithValue(error.response.data.message)
        } else {
          return rejectWithValue(error.message)
        }
      }
    }
  )

export const selectScenariosSlice = createSelector(
  selectScenarios,
  (scenarios: any) => { 
    return scenarios.map((scenario: any) => {
      return scenario;
    })
  }
)

export const scenariosOptions = createSelector(
  selectScenarios,
  (scenarios: IScenario[]) => { 
    return scenarios.map((scenario: IScenario) => {
      return { label: scenario.id, value: scenario.id };
    })
  }
)
